<template>
    <v-autocomplete
        v-model="selected"
        :items="items"
        cache-items
        :loading="loading"
        :search-input.sync="search"
        chips
        item-text="nombre_completo"
        item-value="id"
        label="Cliente:"
        placeholder="Nombre del cliente"
        prepend-icon="mdi-account-search"
        clearable
        multiple
        @click:clear="$emit('selected',[])"
    ></v-autocomplete>
</template>

<script>
    import axios from 'axios';
    export default {
        name: "SearchClientesInput",
        data(){
            return {
                selected : [],
                items : [],
                loading : false,
                search : ''
            }
        },
        mounted(){
            this.loadData();
        },
        watch : {
            search(val){
                // Items have already been requested
                if (this.loading || (typeof (val) !== 'string' || (typeof (val) === 'string' && val.length < 1))) {
                    return
                }

                this.loadData();
            },
            selected(val){
                if(val.length < 1) {
                    return
                }

                this.$emit('selected',this.selected);
            }
        },
        methods : {
            loadData(){
                this.loading = true;

                // Lazily load input items
                axios.get('/api/clientes/listar', {params: {is_list: 1, search: this.search}})
                    .then(({data}) => {
                        this.items = data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        }
    }
</script>

<style scoped>

</style>
